  <div class="modal-backdrop fade show" (click)="close()"></div>
  <div #dialog class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="member-status-title" [attr.aria-busy]="busy">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="member-status-title" class="modal-title">会員在籍ステータスの変更</h5>
          <button type="button" class="close" aria-label="閉じる" [disabled]="busy" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form novalidate #form="ngForm" (ngSubmit)="submit(form)">
          <div class="modal-body">
            @if (operation?.message) { <div class="alert alert-warning" role="alert">{{ operation?.message }}</div> }
            @if ((selectedMemberStatus === 1 || selectedMemberStatus === 2) && !memberRemoveFlg) {
              <label class="row mx-0">
                <div class="col-md-3 custom-control custom-radio">
                  <input [disabled]="blocked" type="radio" id="member_status_0" class="custom-control-input" [(ngModel)]="changeStatus" [value]="0" name="memberStatus">
                  <label class="custom-control-label d-flex" for="member_status_0"><span>在籍中&nbsp;</span></label>
                </div>
                <div class="col-md-2" style="margin-top: -5px;">
                  <label for="member_status_0"><i class="text-success fa fa-3x fa-toggle-on"></i></label>
                </div>
                <div class="col-md-7">
                  <label for="member_status_0"><span>次回売上データ自動作成対象になります。</span></label>
                </div>
              </label>
            }
            @if (selectedMemberStatus === 0 && !memberRemoveFlg) {
              <label class="row mx-0">
                <div class="col-md-3 custom-control custom-radio">
                  <input [disabled]="blocked" type="radio" id="member_status_1" class="custom-control-input" [(ngModel)]="changeStatus" [value]="1" name="memberStatus">
                  <label class="custom-control-label" for="member_status_1"><span>停止</span></label>
                </div>
                <div class="col-md-2" style="margin-top: -5px;">
                  <label for="member_status_1"><i class="text-secondary fa fa-3x fa-toggle-off"></i></label>
                </div>
                <div class="col-md-7">
                  <label for="member_status_1"><span>次回売上データを自動生成しません。</span></label>
                </div>
              </label>
              <hr>
              <label class="row mx-0">
                <div class="col-md-3 custom-control custom-radio">
                  <input [disabled]="blocked" type="radio" id="member_status_2" class="custom-control-input" [(ngModel)]="changeStatus" [value]="2" name="memberStatus">
                  <label class="custom-control-label" for="member_status_2"><span>停止(除名)</span></label>
                </div>
                <div class="col-md-2" style="margin-top: -5px;">
                  <label for="member_status_2"><i class="text-red fa fa-3x fa-toggle-off"></i></label>
                </div>
                <div class="col-md-7">
                  <label for="member_status_2"><span>次回売上データを自動生成しません。</span></label>
                </div>
                <div class="col-md-12">
                  <label for="expulsion-reason"><span>除名理由</span></label>
                  <input [disabled]="blocked" id="expulsion-reason" name="expulsionReason" type="text" [(ngModel)]="expulsionReason" class="form-control" [required]="changeStatus === 2">
                </div>
              </label>
            }
            @if (selectedMemberStatus === 1 && memberRemoveFlg) {
              <label class="row mx-0">
                <div class="col-md-3 custom-control custom-radio">
                  <input [disabled]="blocked" type="radio" id="member_status_3" class="custom-control-input" [(ngModel)]="changeStatus" [value]="3" name="memberStatus">
                  <label class="custom-control-label" for="member_status_3"><span>削除</span></label>
                </div>
                <div class="col-md-2" style="margin-top: -5px;">
                  <label for="member_status_3"><i class="text-red fa fa-3x s-icon-delete"></i></label>
                </div>
                <div class="col-md-7">
                  <label for="member_status_3"><span>月次売上データを自動生成しません。</span></label>
                  <label for="member_status_3"><span>既に作成済みの売上データは削除されません。会員管理画面から会員データを参照できなくなります。</span></label>
                </div>
              </label>
            }
          </div>
          <div class="modal-footer">
            <button class="btn bg-close text-white" type="button" [disabled]="busy" (click)="close()">
              <i class="fa s-icon-cancel"></i>&nbsp;閉じる
            </button>
            <button class="btn btn-primary text-white" type="submit"
              [disabled]="form.invalid || form.pending || blocked || changeStatus == null || (changeStatus === 2 && !expulsionReason.trim())">
              <i class="fa s-icon-turnOver"></i>&nbsp;変更
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
